import React, { useContext, useEffect, useState } from "react";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import SupplierContext from "../../../../contexts/SupplierContext";
import logo from "../../../../assets/images/vistatrac/vistatrac.png";
import { Socket } from "socket.io-client";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import INotification from "../../../../models/INotification";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IUpdateSupplierIntegrationsDTO from "../../../../models/DTO/IUpdateSupplierIntegrationsDTO";
import UserContext from "../../../../contexts/UserContext";

type Props = {
    socket: Socket;
    setActivityIndicator: (activityIndicator: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    isMainViewLight: boolean;
};

export const VistaTracConnect = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const [hasVistaTrac, setHasVistaTrac] = useState(supplierModel.Supplier_Integration.has_vistatrac || false);

    useEffect(() => {
        props.socket.on(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, onUpdateSupplierIntegrations);

        return () => {
            props.socket.removeListener(EndpointsEnum.SupplierOnUpdateSupplierIntegrations, onUpdateSupplierIntegrations);
        };
    }, []);

    const toggleVistaTrac = () => {
        const payload: IUpdateSupplierIntegrationsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            // @ts-expect-error
            Supplier_Integration: {
                has_vistatrac: !supplierModel.Supplier_Integration.has_vistatrac,
            },
        };

        props.socket.emit(EndpointsEnum.SupplierUpdateSupplierIntegrations, payload);
    };

    const onUpdateSupplierIntegrations = () => {};

    return (
        <div className={"VistaTracConnect"}>
            <OwAccordion
                hideChevron={true}
                titleClick={false}
                leftImage={logo}
                leftImageHeight={30}
                rightElem={
                    <div className={"ms-auto"}>
                        <OwToggle fn={toggleVistaTrac} name={"has_opencart"} label={""} active={hasVistaTrac} />
                    </div>
                }></OwAccordion>
        </div>
    );
};
